import { OdataFieldTwoValueOperator } from './OdataFieldTwoValueOperator';
import { IOdataField } from '../../IOdataField';

export class OdataFieldOperatorSubstring extends OdataFieldTwoValueOperator {
  constructor(field: IOdataField, index: IOdataField) {
    super(field, index, 'substring');
  }
}
